<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-lg-4 col-md-4 mt-2 col-12 d-inline-block">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">دسته بندی :</span>
                        </div>
                        <vs-select :data="categories" :mode="'create'"
                                   :header="{multiple: false, label: 'name'}"
                                   @onChange="onSelectCategory"></vs-select>
                    </div>
                </div>
                <div class="col-12 col-md-4 mt-2 col-lg-6">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput" ref="searchInput" v-model="searchString">
                    </div>
                </div>
                <div class="col-12 col-md-4 mt-2 col-lg-2 text-center">
                    <button class="btn btn-primary" @click="onModalButtonClick">افزودن محصول</button>
                </div>
            </div>
        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-4">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-3">
                            <span>دسته بندی: </span>
                            <span>{{item.categoryName}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>واحد: </span>
                            <span v-if="units[item.unitId-1] !== undefined">{{units[item.unitId-1].unitName}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>موجودی: </span>
                            <span>{{item.stock < 0 ? '(' + (item.stock * -1).toLocaleString()+"-)": item.stock.toLocaleString()}}</span>
                        </div>
                        <!--<div class="col-md-3">-->
                        <!--<span>قیمت: </span>-->
                        <!--<span v-if="item.price === null" class="text-warning">قیمت ثبت نشده است!</span>-->
                        <!--<span v-else class="text-success">{{item.price.toLocaleString()}}</span>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>

                            <!--<span>موجودی انبار:</span>
                            <span>{{item.stock}}</span>-->
                            <!--<span>تعداد:</span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>-->
                            <span>دسته بندی:</span>
                            <span> {{item.categoryName}}</span>
                            <br>
                            <span>واحد:</span>
                            <span v-if="units[item.unitId-1] !== undefined"> {{units[item.unitId-1].unitName}}</span>
                            <br>
                            <span>موجودی:</span>
                            <span>{{item.stock < 0 ? '(' + (item.stock * -1).toLocaleString()+"-)": item.stock.toLocaleString()}}</span>
                            <br>
                            <span>بارکد:</span>
                            <span> {{item.barcode}}</span>
                            <!--<div class="text-warning text-center mt-3" v-if="item.price === null">-->
                            <!--<h5 class="d-inline">قیمت ثبت نشده است!</h5>-->
                            <!--</div>-->
                            <!--<div v-else class="text-success text-center mt-3">-->
                            <!--<h5 class="d-inline">قیمت:</h5>-->
                            <!--<h5 class="d-inline"> {{item.price.toLocaleString()}}</h5>-->
                            <!--</div>-->
                        </div>
                        <div class="col-4 d-flex align-items-center">
                            <img class="view-image" :src="item.imageAddress!==null && item.imageAddress !='' ? validateImageUrl(item.imageAddress) :noImageUrl()">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12"
                 :style="[autoload && products.length < dataCount ? {'height': '125px'} : {'height': 'initial'}]">
                <div class="sk-circle" id="loading"
                     :style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center mb-3 mt-1"
                 @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>

            <div class="modal fade" id="productModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 v-if="params.mode === 'create'" class="modal-title text-white">ایجاد
                                محصول</h5>
                            <h5 v-if="params.mode === 'edit'" class="modal-title text-white">ویرایش
                                محصول</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="row">
                                <div class="col-lg-9 col-md-12 col-sm-12 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">دسته بندی</span>
                                        </div>
                                        <vs-select :data="categories" :selected-val="preselectedCategory"
                                                   :mode="'create'"
                                                   :header="{multiple: false, label: 'name'}"
                                                   @onChange="onCategoryChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-12 col-sm-12 text-center">
                                    <button class="btn btn-primary bg-danger-grad border-0"
                                            @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom"
                                            title="افزودن دسته بندی">افزودن دسته بندی
                                    </button>
                                </div>
                                <div class="col-lg-12 mt-3 mt-lg-0">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">نام محصول</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.productName">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">واحد</span>
                                        </div>
                                        <vs-select :data="units" :selected-val="preselectedUnit" :options={}
                                                   :mode="'create'" :header="{multiple: false, label: 'unitName'}"
                                                   @onChange="onUnitChange"></vs-select>
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <button type="button" class="d-inline-block btn btn-info mx-2 barcode"
                                                @click="openBarcode"><i
                                                class="fa fa-camera"></i></button>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">بارکد</span>
                                        </div>
                                        <input class="form-control" type="number" v-model="product.barcode"
                                               placeholder="برای قرائت بارکد روی آیکون کلیک کنید">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">تعداد هشدار کسر موجودی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.lessAmount">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">کد فنی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.technicalCode">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">شناسه مالیاتی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.taxCode">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">درصد مالیات</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.defultTaxPercent">
                                    </div>
                                </div>
                                <div class="col-lg-6 mt-3">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">کد محصول</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="product.productCode">
                                    </div>
                                </div>
                                <div class="col-12 text-center">
                                    <div class="">
                                        <small class="d-flex justify-content-center">فقط فایلهای عکسی، تکسی، زیپ، پی دی اف قابل بارگزاری هستند</small>
                                        <small class="d-flex justify-content-center"> (jpg/jpeg/png/txt/doc/docx/zip/rar/pdf)</small>
                                        <span class="" v-for="vi in viewList">
                                            <img :src="validateImageUrl(vi.address)" class="profile-image ">
                                            (<i class="fa fa-trash clickable" title="حذف فایل ضمیمه" @click="deleteAtachFile2(vi)"></i>)
                                            <hr/>
                                        </span>
                                        <span class="" v-for="item in documentList">
                                            <img :src="item.newImage" class="profile-image ">
                                            (<i class="fa fa-trash clickable" title="حذف فایل ضمیمه" @click="deleteAtachFile(item)"></i>)
                                            <hr/>
                                        </span>
                                    </div>
                                    <input type="file" id="fileUpload" class="d-none"
                                           @change="onImageChange($event)">
                                    <label for="fileUpload" class="btn btn-info btn-round mb-3 clickable">بارگذاری
                                        فایل</label>
                                </div>
                            </div>
                            <!--<div class="table-responsive">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>نام محصول</th>
                                        <th class="text-center">قیمت</th>
                                        <th class="text-center">تعداد</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in cart">
                                        <td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>
                                        <td>{{item.productName}}</td>
                                        <td class="text-center">
                                            <input class="form-control" type="number" v-model="item.price">
                                        </td>
                                        <td class="text-center">
                                            <input class="form-control" type="number" v-model="item.unitVal">
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h4 class="text-center mt-5" v-if="cart.length < 1">محصولی ثبت نشده است!</h4>
                            </div>-->
                        </div>
                        <div class="modal-footer d-block mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>
                            <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="barcodTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="barcodTitle">خواندن بارکد
                                محصول</h5>

                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="row">
                                <div class="col-12">

                                    <StreamBarcodeReader
                                            @decode="(a, b, c) => onDecode(a, b, c)"
                                            @loaded="() => onLoaded()"
                                    ></StreamBarcodeReader>
                                    <h5 class="col-12 text-center m-3">
                                        {{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-block mt-3">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <!--<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>-->
                            <!--<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="category-modal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-danger glow-warning">
                            <h5 class="modal-title text-white">افزودن دسته بندی</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row text-center">
                                <div class="col-lg-6 mb-2">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">عنوان دسته بندی</span>
                                        </div>
                                        <input class="form-control" type="text" v-model="categoryName">
                                    </div>
                                </div>
                                <!--<div class="col-lg-6 mb-2">-->
                                <!--<div class="input-group">-->
                                <!--<div class="input-group-prepend">-->
                                <!--<span class="input-group-text">دسته بندی مادر</span>-->
                                <!--</div>-->
                                <!--<vs-select-->
                                <!--:data="categories"-->

                                <!--:mode="'create'"-->
                                <!--:header="{multiple: false, label: 'name'}"-->
                                <!--@onChange="onCategoryChange"-->
                                <!--&gt;</vs-select>-->
                                <!--</div>-->
                                <!--</div>-->
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" @click="onCreateCategory">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import VsSelect from '../_framework/VsSelect.vue';
    import EventBus from "../_framework/event-bus.js";
    import {StreamBarcodeReader} from "vue-barcode-reader";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#productModal").modal("show");
    });

    export default {
        name: 'products',
        components: {
            VsSelect,
            StreamBarcodeReader
        },
        data() {
            return {
                barcodeInputTimeout: null,
                isBarcodeScanning: false,
                newImageCliked: false,
                documentList: [],
                viewList: [],
                helpDocumentModel: {},
                products: [],
                units: [],
                categories: [],
                preselectedUnit: {},
                preselectedCategory: {},
                params: {
                    mode: 'create'
                },
                queryParams: {
                    name: "",
                    showAll: false,
                    pageSize: 18,
                    pageIndex: 0,
                },
                searchString: "",
                modalProductName: "",
                product: {
                    productName: "",
                    unitId: 0,
                    barcode: "",
                    categoryId: 0,
                    productImages: [],
                    defultTaxPercent:0,
                },
                dataCount: 0,

                listView: false,
                autoload: false,
                isSending: false,
                isPaying: false,
                barcode: "",
                categoryName: "",
            }
        },
        mounted() {
            // console.log("prodddd")
            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            // console.log(this.queryParams);
            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                $("#loading").hide();
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });
            new BaseService('units').getAll().then(response => {
                this.units = response.data;
            }).catch(error => {
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });

            this.getCategories();

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts();
                    }
                });
            }
            /*new BaseService('categories').getAll().then(response => {
                this.categories = response.data.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.data.message, this.$noty);
            });*/
            this.$refs.searchInput.focus();
        },
        methods: {
            getCategories() {
                new BaseService('categories').getAll().then(response => {
                    this.categories = response.data;
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            getProducts() {
                this.queryParams.pageIndex++;
                console.log(this.queryParams)
                $("#loading").show();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    for (let i of this.products) {
                        i.image = i.images;
                        i.images = [];
                    }
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    $("#loading").hide();
                    Utils.handleErrorWithNotification(error.messages, this.$noty);
                });
            },
            onUnitChange(e) {
                if (e && e.id != null) {
                    this.preselectedUnit = e;
                    this.product.unitId = e.id;
                }
            },
            onSearchInput() {
                if (this.barcodeInputTimeout) {
                    clearTimeout(this.barcodeInputTimeout);
                }
                this.barcodeInputTimeout = setTimeout(() => {


                    this.queryParams.name = this.searchString;
                    let queryParams2 = {
                        name: this.searchString,
                        showAll: false,
                        pageSize: 18,
                        pageIndex: 0,
                    };
                    // this.queryParams.categoryId = 0;
                    // this.queryParams.pageIndex = 0;
                    $("#loading").hide();
                    new BaseService('product', '/get').getList(queryParams2).then(response => {
                        // new BaseService('product?pageSize='
                        //     + this.queryParams.pageSize
                        //     + '&pageIndex='
                        //     + this.queryParams.pageIndex
                        //     + '&name='
                        //     + this.queryParams.name
                        //     + '&showAll='
                        //     + this.queryParams.showAll).getList().then(response => {
                        this.products = response.data.data;
                        $("#loading").hide();
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });


                }, 300);
            },
            onCardClicked(e, index) {
                this.product = this.products[index];
                this.params.mode = 'edit';
                for (let item of this.units) {
                    if (item.id === this.product.unitId) {
                        this.preselectedUnit = item;
                    }
                }
                // console.log(this.categories)
                // console.log(this.product)

                for (let item of this.categories) {
                    if (item.id === this.product.categoryId) {
                        this.preselectedCategory = item;
                    }
                }
                this.product.productImages = [];
                console.log(this.product);
                var add = `product/getproductImages`;
                this.documentList = [];
                this.viewList = [];
                new BaseService(add).getById(this.products[index].id).then(response => {
                    this.viewList = response.data;
                }).catch(error => {
                    console.log(error);
                });
                $("#productModal").modal("show");
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.cart[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                }
                this.cart.splice(index, 1);

            },
            onModalButtonClick() {
                $("#productModal").modal("show");
                let na = this.product.productName;
                this.product = {};
                if (this.preselectedUnit.id !== null) {
                    this.product.unitId = this.preselectedUnit.id;
                }
                if (this.preselectedCategory.id !== null) {
                    this.product.categoryId = this.preselectedCategory.id;
                }
                if (na !== null && na !== '') {
                    this.product.productName = na;
                }
                this.product.productImages = [];
                this.documentList = null;
                this.helpDocumentModel = null;
                this.params.mode = 'create';
            },
            onModalDelete() {
                if (confirm("آیا از حذف این محصول اطمینان دارید؟")) {
                    new BaseService('product').delete(this.product.id).then(response => {
                        this.$noty.warning("با موفقیت حذف شد!");
                        $("#productModal").modal("hide");
                        new BaseService('product', '/get').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });

                }
            },
            onModalOk() {
                if (this.params.mode === 'create') {
                    this.onCreate(this.product);
                } else {
                    this.onUpdate(this.product);
                }
            },
            onCreate(product) {
                if (!this.isPaying) {
                    this.isPaying = true;
                    console.log(product)
                    if (product.categoryId === undefined || product.categoryId === null) {
                        Utils.handleErrorWithNotification("لطفا دسته بندی را انتخاب کنید", this.$noty);
                    } else if (product.unitId === undefined || product.unitId === null) {
                        Utils.handleErrorWithNotification("لطفا واحد را انتخاب کنید", this.$noty);
                    } else {
                        product.rowVersion = this.generateUuid();
                        new BaseService('product').create(product).then(response => {
                            this.$noty.success("موفقیت آمیز!");
                            $("#productModal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                                this.products = response.data.data;
                                $("#loading").hide();
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                            });
                            this.isPaying = false;
                        }).catch(error => {
                            this.isPaying = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                        })
                    }
                }
            },
            onUpdate(product) {
                if (!this.isPaying) {
                    this.isPaying = true;
                    // console.log(product)
                    new BaseService('product').update(product).then(response => {
                        this.$noty.success("موفقیت آمیز!");
                        $("#productModal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        new BaseService('product', '/get').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                        });
                        this.isPaying = false;
                    }).catch(error => {
                        this.isPaying = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                        Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                    });
                }
            },
            onCategoryChange(e) {
                if (e && e.id != null) {
                    this.preselectedCategory = e;
                    this.product.categoryId = e.id;
                }
            },
            onAddCategoryClicked() {
                $("#category-modal").modal("show");
                // $("#productModal").modal("hide");
                // this.$router.push({name: 'category'});
            },
            onSelectCategory(val) {
                if (val) {
                    this.queryParams.categoryId = val.id;
                    this.queryParams.pageIndex = 0;
                    $("#loading").hide();
                    new BaseService('product', '/get').getList(this.queryParams).then(response => {
                        // new BaseService('product?pageSize='
                        //     + this.queryParams.pageSize
                        //     + '&pageIndex='
                        //     + this.queryParams.pageIndex
                        //     + '&name='
                        //     + this.queryParams.name
                        //     + '&showAll='
                        //     + this.queryParams.showAll).getList().then(response => {
                        this.products = response.data.data;
                        $("#loading").hide();
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                } else {
                    console.log("asdasdadad")
                    this.queryParams = {
                        name: "",
                        showAll: false,
                        pageSize: 18,
                        pageIndex: 0,
                    };
                    new BaseService('product', '/get').getList(this.queryParams).then(response => {
                        this.products = response.data.data;
                        this.dataCount = response.data.count;
                        $("#loading").hide();
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onDecode(a, b, c) {
                // console.log(a, b, c);
                this.barcode = a;
                this.product.barcode = a;
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                // console.log("load");
            },
            openBarcode() {
                this.barcode = "";
                $("#barcodeModal").modal("show");
            },
            onCreateCategory() {
                if (!this.isSending) {
                    this.isSending = true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: 0,
                        // parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').create(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت افزوده شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending = false;
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            onImageChange(e) {
                let files = e.target.files;
                let app = this;
                if (files && files[0]) {
                    this.newImageCliked = true;
                    for (let item of files) {
                        let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            // $("#bannerImg").attr("src", e.target.result);
                            let a = e.target.result;
                            // let img = document.getElementById('docImg');
                            // img.src = e.target.result;
                            let bb = {};
                            bb.name = item.name;
                            bb.address = a.substring(a.indexOf(',') + 1, a.length);
                            bb.extension = extension;
                            bb.newImage = e.target.result;
                            app.isSending = true;
                            new BaseService("Product", "/CreateProductImage").create(bb).then(response => {
                                bb.documentId = response.data;
                                // let attach = {documentId: response.data};
                                app.product.productImages.push(response.data);
                                app.isSending = false;
                                app.helpDocumentModel = bb;
                            }).catch(error => {
                                app.isSending = false;
                                app.$noty.error("متاسفانه خطایی رخ داده است." + error.data);
                                console.log(error)
                                // Utils.handleErrorWithNotification("خطا!! لطفا پارامترها را مجددا بررسی کنید", this.$noty);
                            });

                        };
                        reader.readAsDataURL(item);
                        // } else {
                        //     alert("لطفا فایل عکس بارگذاری کنید");
                        // }
                    }
                }
            },
            deleteAtachFile(item) {
                this.product.productImages.splice(this.product.productImages.indexOf(item.documentId), 1);
                this.documentList.splice(this.documentList.indexOf(item), 1);
            },
            deleteAtachFile2(item) {
                new BaseService("product/DeleteImages").delete(item.id).then(response => {
                    this.viewList.splice(this.viewList.indexOf(item), 1);
                }).catch(error => {
                    console.log(error);
                });
            },


        },
        watch: {
            helpDocumentModel(val) {
                if (this.helpDocumentModel != null) {
                    if (this.documentList === null) {
                        this.documentList = [];
                    }
                    this.documentList.push(val);
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#productModal").hasClass("show")) {
                $("#productModal").modal("hide");
                next(false);
            } else {
                next();
            }
        },

        // created() {
        //     const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
        //         this.back();
        //
        //         // next(false)
        //     });
        //
        //     this.$once('hook:destroyed', () => {
        //         unregisterRouterGuard()
        //     });
        // },


    }
</script>

<style lang="scss">
    .vs-select {
        flex: 1;
    }

    @media (max-width: 991px) {
        .barcode {
            display: block !important;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none !important;
        }
    }

    .v-select .dropdown-toggle {
        padding: 4px 0 4px;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }

    .vs-select .dropdown-toggle::after {
        display: none;
    }

    .v-select .dropdown-toggle .clear {
        margin-top: 5px;
    }
</style>